<script lang="ts" setup>

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none">
    <path d="M1 9.14706V10.3235C1 10.6355 1.12395 10.9348 1.34458 11.1554C1.56521 11.3761 1.86445 11.5 2.17647 11.5H9.23529C9.54731 11.5 9.84655 11.3761 10.0672 11.1554C10.2878 10.9348 10.4118 10.6355 10.4118 10.3235V9.14706M2.76471 5.61765L5.70588 8.55882M5.70588 8.55882L8.64706 5.61765M5.70588 8.55882V1.5" stroke="#0D3048" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style scoped lang="scss">

</style>